import Admin from "@system/config/admin";
import Api from "../APIHandler";

const API = new Api({});

class OrderAdminAPICall {

    getAdminOrderList = async (params) => {
        let res = {};
        const param = {}
        param.data = params
        try {
            await API.post(Admin.ADMIN_ORDER, param).then((resHer) => {
                if (resHer.data.isSuccessFull) {
                    res = resHer.data.data;
                }
            });
        } catch (e) {
            res = e?.response?.data
        }
        return res
    }

    getAdminOrderInsightInfo = async (params) => {
        let res = {};
        const param = { params }
        try {
            await API.post(Admin.ADMIN_ORDER_INSIGHT_INFO, param).then((resHer) => {
                if (resHer.data.isSuccessFull) {
                    res = resHer.data.data;
                }
            });
        } catch (e) {
            res = e?.response?.data
        }
        return res
    }

    getAdminOrderInsightList = async (params) => {
        let res = {};
        const param = { params }
        try {
            await API.post(Admin.ADMIN_ORDER_INSIGHT, param).then((resHer) => {
                if (resHer.data.isSuccessFull) {
                    res = resHer.data.data;
                }
            });
        } catch (e) {
            res = e?.response?.data
        }
        return res
    }

    adminOrderReprocess = async (params) => {
        let res = {};
        const param = { params }
        try {
            await API.post(Admin.ADMIN_ORDER_REPROCESS, param).then((resHer) => {
                res = resHer.data;
            });
        } catch (e) {
            res = e?.response?.data
        }
        return res
    }

    getOrderInsightExportAll = async (params) => {
        let res = "";
        const param = { params }
        try {
            await API.post(Admin.ADMIN_ORDER_INSIGHT_EXPORT_ALL, param).then((resHer) => {
                res = resHer.data;
            });
        } catch (e) {
            res = e?.response?.data
        }
        return res
    }

    getOrderAuditLog = async (params) => {
        let res = "";
        const param = {}
        param.params = { orderNumber: params.OrderId }

        await API.post(Admin.ADMIN_ORDER_AUDIT_LOG, param).then((resHer) => {
            if (resHer?.data) {
                res = resHer.data
            }
        })

        return res;
    }

    updateAdminOrderDetails = async (params) => {
        let res = "";
        const param = {}
        param.data = params
        await API.post(Admin.ADMIN_ORDER_UPDATE_DETAILS, param).then((resHer) => {
            if (resHer?.data) {
                res = resHer.data
            }
        })

        return res;
    }
}


export default OrderAdminAPICall;


